import type { PendingPreAuthorizationRequest, PreAuthorization } from '@gozoki/api-types'
import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import {
  fetchPendingPreAuthorizationRequests,
  fetchPreAuthorizations,
} from '../queries/preAuthorizations.queries'

export const usePreAuthorizations = (
  storeId: number,
): UseQueryResult<PreAuthorization[], unknown> =>
  useQuery({
    queryKey: ['pre-authorizations', storeId],
    queryFn: () => fetchPreAuthorizations(storeId),
  })

export const usePendingPreAuthorizationRequests = (
  storeId: number,
): UseQueryResult<PendingPreAuthorizationRequest[], unknown> =>
  useQuery({
    queryKey: ['pre-authorization-requests', storeId],
    queryFn: () => fetchPendingPreAuthorizationRequests(storeId),
  })
